import type { RectangleButtonProps } from './RectangleButton';

import { styled } from 'styled-components';

import { ButtonContent } from '../Button';
import { primaryButtonColorsAqua, primaryButtonColorsGreen } from '../PrimaryButton';

import { DefaultRectangleButtonSC } from './RectangleButton';

type Props = RectangleButtonProps & {
  colorVariant?: 'green' | 'aqua';
};

const PrimaryButtonSC = styled(DefaultRectangleButtonSC)<{ $colorVariant?: 'green' | 'aqua' }>`
  ${(props) => {
    switch (props.$colorVariant) {
      case 'aqua':
        return primaryButtonColorsAqua;
      default:
        return primaryButtonColorsGreen;
    }
  }}

  &:disabled {
    color: ${(props) => props.theme.colors.shadows.oxfordBlue[80]};
    background: ${(props) => props.theme.colors.shadows.oxfordBlue[30]};
    border-color: ${(props) => props.theme.colors.shadows.oxfordBlue[30]};
  }
`;

export const PrimaryRectangleButton = ({ children, colorVariant, leftIcon, rightIcon, topIcon, ...props }: Props) => {
  return (
    <PrimaryButtonSC $colorVariant={colorVariant} {...props}>
      <ButtonContent leftIcon={leftIcon} rightIcon={rightIcon} topIcon={topIcon}>
        {children}
      </ButtonContent>
    </PrimaryButtonSC>
  );
};
